const defaultMarkdown = `# Welcome to Markdown Previewer
## Created by: Veljko SPASIC
<br />

[Veljko Spasic](https://www.veljko.app)
<br />

\`Inline code\`
<br />

\`\`\`
Block of code
console.log("Hello, world!");

\`\`\`
<br />

- List item 1
- List item 2
- List item 3

<br />

> Blockquote example

![Markdown Logo](https://markdown-here.com/img/icon256.png)

<br />

**Bold Text**
`;

export default defaultMarkdown;
